import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Writing } from "@/components/Writing";
import { Podcast } from "@/components/Podcast";
import { Speaking } from "@/components/Speaking";
import { Retreat } from "@/components/Retreat";
import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Writing />
        <Podcast />
        <Speaking />
        <Retreat />
        <Enquiry />
      </main>
      <Footer />
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0B1140", color: "#F5EFDD", border: "1px solid rgba(227,194,74,0.4)" } }} />
    </div>
  );
}

export default App;
